<template>
  <v-dialog persistent v-model="openFilterDialog" :width="dialogWidth">
    <template v-slot:activator="{ on, attrs }">
      <v-tooltip bottom>
        <template v-slot:activator="{ on: tooltip }">
          <v-badge
            :value="isChips"
            color="light-green"
            class="mx-1 badge-position"
          >
            <v-btn
              v-if="isIcon"
              :class="
                newClass ? newClass : 'px-2 py-5 ma-0 secondary  btn-filter-box'
              "
              depressed
              v-bind="attrs"
              v-on="{ ...tooltip, ...on }"
            >
              <v-icon :size="iconSize">mdi-filter</v-icon>
            </v-btn>
            <v-btn
              v-else
              small
              class="btn-filter-small rounded-lg"
              :class="newClass"
              color="primary"
              outlined
              depressed
              v-bind="attrs"
              v-on="{ ...tooltip, ...on }"
            >
              <v-icon small class="mr-2">mdi-filter</v-icon>
              <span>Filters</span>
            </v-btn>
          </v-badge>
        </template>
        <span class="text-capitalize">filters</span>
      </v-tooltip>
    </template>

    <v-card>
      <v-card-title class="heading lighten-3 d-flex align-center py-2">
        <h5
          class="text_color--text text-uppercase font-weight-bold"
          v-if="title"
        >
          {{ title }}
        </h5>
        <v-spacer />
        <v-btn icon @click="openFilterDialog = false">
          <v-icon color="text_color">mdi-close</v-icon>
        </v-btn>
      </v-card-title>
      <v-divider></v-divider>
      <v-card-text class="py-2">
        <slot name="form"></slot>
      </v-card-text>
      <v-card-actions class="px-6 pb-4">
        <v-spacer></v-spacer>
        <SecondaryButton
          text
          @click="openFilterDialog = false"
          name="Cancel"
        />
        <SecondaryButton @click="$emit('reset')" name="Reset" outlined />
        <PrimaryButton @click="applyFilter" name="Apply"> </PrimaryButton>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  emits: ["filterDialogOpen", "reset"],
  props: {
    isIcon: {
      type: Boolean,
      default: true,
    },
    title: {
      type: String,
      required: true,
    },
    isChips: {
      type: Boolean,
      default: false,
    },
    newClass: {
      type: String,
    },
    iconSize: {
      type: String,
    },
    dialogWidth: {
      default: 500,
    },
  },
  data() {
    return {
      openFilterDialog: false,
    };
  },
  watch: {
    openFilterDialog(val) {
      if (val) {
        this.$emit("filterDialogOpen");
      }
    },
  },
  methods: {
    applyFilter() {
      this.$emit("submit");
      this.openFilterDialog = false;
    },
  },
};
</script>

<style lang="scss">
.btn-filter-small {
  height: 34px !important;
}
.badge-position {
  .v-badge__wrapper {
    left: -6px;
    top: 5px;
  }
  .v-badge__badge {
    height: 12px;
    min-width: 12px !important;
  }
}
.btn-filter-box {
  min-width: 40px !important;
  width: 40px !important;
  height: 33px !important;
}
</style>
